const updateCanvas = ({ svgCanvas, cnvs, curConfig, center, newCtr = {} }) => {
    const workarea = cnvs.parentNode;
    if (!workarea)
        return;
    let { width: w, height: h } = workarea.getBoundingClientRect();
    const wOrig = w;
    const hOrig = h;
    const oldCtr = {
        x: workarea.scrollLeft + wOrig / 2,
        y: workarea.scrollTop + hOrig / 2,
    };
    const multi = curConfig.canvas_expansion;
    const zoom = svgCanvas.getZoom();
    w = Math.max(wOrig, svgCanvas.contentW * zoom * multi);
    h = Math.max(hOrig, svgCanvas.contentH * zoom * multi);
    if (w === wOrig && h === hOrig) {
        workarea.style.overflow = "hidden";
    }
    else {
        workarea.style.overflow = "scroll";
    }
    const { width: cw, height: ch } = cnvs.getBoundingClientRect();
    const oldCanY = ch / 2;
    const oldCanX = cw / 2;
    cnvs.style.width = `${w}px`;
    cnvs.style.height = `${h}px`;
    const newCanY = h / 2;
    const newCanX = w / 2;
    const offset = svgCanvas.updateCanvas(w, h);
    const ratio = newCanX / oldCanX;
    const scrollX = w / 2 - wOrig / 2;
    const scrollY = h / 2 - hOrig / 2;
    if (!newCtr.x) {
        const oldDistX = oldCtr.x - oldCanX;
        const newX = newCanX + oldDistX * ratio;
        const oldDistY = oldCtr.y - oldCanY;
        const newY = newCanY + oldDistY * ratio;
        newCtr.x = newX;
        newCtr.y = newY;
    }
    else {
        newCtr.x += offset.x;
        newCtr.y += offset.y;
    }
    if (center) {
        if (svgCanvas.contentW > workarea.getBoundingClientRect().width) {
            workarea.scrollLeft = offset.x - 10;
            workarea.scrollTop = offset.y - 10;
        }
        else {
            workarea.scrollLeft = scrollX;
            workarea.scrollTop = scrollY;
        }
    }
    else {
        workarea.scrollLeft = newCtr.x - wOrig / 2;
        workarea.scrollTop = newCtr.y - hOrig / 2;
    }
};
export default updateCanvas;
